<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.ships') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="shipsTable.additionalFilters"
									:default-sort="shipsTable.defaultSort"
									:excel="true"
									:fields="shipsTable.headers"
									:header-selection-key="'ships-headers'"
									:height="shipsTable.height"
									:total-records="shipsTable.total"
									:filter-save-key="'ships-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in shipsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="shipsTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="shipsTable.selectedHeaders.includes('name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.name }}</b>
										</td>
										<td
											v-if="shipsTable.selectedHeaders.includes('location')"
											@click="editClick(item.id, false)"
										>
											{{ item.location }}
										</td>
										<td
											style="text-align: right"
											v-if="shipsTable.selectedHeaders.includes('price')"
											@click="editClick(item.id, false)"
										>
											{{
												item.price != null
													? Number.isInteger(item.price)
														? item.price.toLocaleString('hr') + ',00'
														: /^\d+\.\d{1}$/.test(item.price.toString())
														? item.price.toLocaleString('hr') + '0'
														: item.price.toLocaleString('hr')
													: ''
											}}
										</td>
										<td
											v-if="shipsTable.selectedHeaders.includes('partner_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.partner.name }}</b>
										</td>
										<td
											v-if="shipsTable.selectedHeaders.includes('active')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.active" small>fa-check</v-icon>
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Ships',
	components: { TheTable },
	data: function () {
		return {
			shipsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '60px', allowFilter: true },
					{ text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.locationPort'), value: 'location', type: 'string', allowFilter: true },
					{ text: this.$t('fields.price'), value: 'price', type: '', allowFilter: true, alignRight: true },
					{
						text: this.$t('fields.company'),
						value: 'partner_id',
						type: 'multiple|partners',
						allowFilter: true,
					},
					{
						text: this.$t('fields.active'),
						value: 'active',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [{ text: this.$t('fields.price'), value: 'price', type: 'price_range' }],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'name',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/ships/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/ships/' + id);
			} else {
				let routeData = this.$router.resolve('/ships/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.shipsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.shipsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'ships',
				request,
				(data, success) => {
					if (success) {
						vm.shipsTable.items = data.items;
						vm.shipsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.shipsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'ships',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/ships', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.shipsTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		if (this.$myStore.state.user.user_role_id == 2) {
			this.$router.replace('/candidates');
		}
		this.$myStore.commit('setBreadcrumbs', [{ text: this.$t('modules.ships'), href: '/#/ships', disabled: true }]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
